import { getAuthHeaders, tempMeeApi } from '~/services/api';
import type { ISendOtpApiPayload, TSendOtpApiResponse } from '../types/PhoneVerification.api';

export const sendOtp = async (payload: ISendOtpApiPayload): Promise<TSendOtpApiResponse> => {
  const headers = await getAuthHeaders();
  const { data } = await tempMeeApi.post<TSendOtpApiResponse>(
    '/auth-service/otp',
    payload,
    { headers },
  );
  return data;
};
